import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { organizationServices } from '../../index';

export const useGetPaymentMethods = (params = {}, options = {}) => {
  const { filters: { searchTerm = '' } = {} } = params;

  return useQuery(
    ['paymentMethods', searchTerm],
    () =>
      organizationServices.getPaymentMethods(cleanObjectEmptyFields({ filters: { searchTerm } })),
    options
  );
};
